import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class SecurityProxy extends ProxyBase {
  postCapitalEarningLeverage(params) {
    return this.post('CapitalEarningandLeverage', params)
  }
  downloadCapitalEarningLeverage(params) {
    return this.post('CapitalEarningandLeverage/Export', params, {}, 'download')
  }
  postFundingLiquidity(params) {
    return this.post('FundingAndLiquidity', params)
  }
  downloadFundingLiquidity(params) {
    return this.post('FundingAndLiquidity/Export', params, {}, 'download')
  }
}

export default new SecurityProxy('IndustryAnalysis/')
